import { get, post, put, destroy } from '../../../methods'
import apiUrl from '../../../Url/ApiUrl'
import DataTypeModel from '../../../../models/DataType'
import { AxiosResponse } from 'axios'
import { DeclineData } from '../../../../interfaces/DeclineData'

export const getTempoQuotes = (parameters: Record<string, any>, cancelToken): Promise<AxiosResponse<any[]>> =>
    post(apiUrl.quotes.tempoQuotes, DataTypeModel(parameters), cancelToken)

export const postTempoNewQuote = (requestBody: Record<string, any>): Promise<AxiosResponse<Record<string, any>>> =>
    post(apiUrl.quotes.tempoNewQuote, DataTypeModel(requestBody))

export const getTempoQuote = (uriParams: { id: string }, cancelToken): Promise<AxiosResponse<Record<string, any>>> =>
    get(apiUrl.quotes.tempoQuote, DataTypeModel({}, uriParams), cancelToken)

export const updateTempoQuote = (
    requestBody: Record<string, any>,
    uriParams: { id: string },
): Promise<AxiosResponse<any[]>> => put(apiUrl.quotes.tempoUpdateQuote, DataTypeModel(requestBody, uriParams))

export const deleteTempoQuote = (uriParams: { id: string }, cancelToken): Promise<AxiosResponse<Record<string, any>>> =>
    destroy(apiUrl.quotes.tempoDeleteQuote, DataTypeModel({}, uriParams), cancelToken)

export const acceptQuote = (uriParams: { quoteId: string }): Promise<AxiosResponse<any[]>> =>
    put(apiUrl.quotes.tempoAcceptQuote, DataTypeModel({}, uriParams))

export const declineQuote = (bodyRequest: DeclineData, uriParams: { quoteId: string }): Promise<AxiosResponse<any[]>> =>
    put(apiUrl.quotes.tempoDeclineQuote, DataTypeModel(bodyRequest, uriParams))
